import React from 'react';
import { Section, Container } from '../../common/UI';
import AboutContent from './AboutContent';
import AboutImage from './AboutImage';
import AboutStats from './AboutStats';

const About = () => {
  return (
    <Section id="about" background="default" padding="default">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            About Me
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            From university graduate to full-stack developer - here's my journey in tech
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
          <AboutImage />
          <AboutContent />
        </div>
        
        <AboutStats />
      </Container>
    </Section>
  );
};

export default About;